import React, { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import baseURL from '../../Components/url';
import './Solicitudes.css';

const ESTADOS = {
    pendiente: '#DAA520',
    aprobada: '#2e7d32',
    rechazada: '#c62828',
    revisando: '#0c71cf',
};

export default function Solicitudes() {
    const [admin, setAdmin] = useState(null);
    const [chequeando, setChequeando] = useState(true);
    const [solicitudes, setSolicitudes] = useState([]);

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const [tab, setTab] = useState('solicitudes');
    const [clientes, setClientes] = useState([]);
    const [cargandoClientes, setCargandoClientes] = useState(false);

    const cargarSolicitudes = async () => {
        try {
            const r = await fetch(`${baseURL}/solicitudesGet.php`, { credentials: 'include' });
            const data = await r.json();
            if (data.solicitudes) setSolicitudes(data.solicitudes);
        } catch (err) {
            console.error(err);
        }
    };

    const cargarClientes = async () => {
        try {
            setCargandoClientes(true);
            const r = await fetch(`${baseURL}/clientesGet.php`, { credentials: 'include' });
            const data = await r.json();
            if (data.clientes) setClientes(data.clientes);
        } catch (err) {
            console.error(err);
        } finally {
            setCargandoClientes(false);
        }
    };

    useEffect(() => {
        if (!admin || tab !== 'clientes') return;
        cargarClientes();
        const interval = setInterval(cargarClientes, 30000);
        return () => clearInterval(interval);
    }, [admin, tab]); // eslint-disable-line react-hooks/exhaustive-deps

    const formatearFecha = (f) => {
        if (!f) return '—';
        const [fecha, hora] = String(f).split(' ');
        const [y, m, d] = (fecha || '').split('-');
        return y && m && d ? `${d}/${m}/${y}${hora ? ' ' + hora : ''}` : f;
    };

    useEffect(() => {
        (async () => {
            try {
                const r = await fetch(`${baseURL}/masterUser.php`, { credentials: 'include' });
                const data = await r.json();
                if (data && data.idAdmin) {
                    setAdmin(data);
                    await cargarSolicitudes();
                }
            } catch (err) {
                console.error(err);
            } finally {
                setChequeando(false);
            }
        })();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const handleLogin = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('email', email);
        formData.append('contrasena', password);
        try {
            const r = await fetch(`${baseURL}/masterLogin.php`, {
                method: 'POST',
                body: formData,
                credentials: 'include',
            });
            const data = await r.json();
            if (data.admin) {
                setAdmin(data.admin);
                await cargarSolicitudes();
            } else if (data.error) {
                toast.error(data.error);
            }
        } catch (err) {
            toast.error('Error al iniciar sesión');
        }
    };

    const rechazar = async (solicitud) => {
        const confirmar = await Swal.fire({
            title: 'Rechazar solicitud',
            text: `¿Rechazar la solicitud de "${solicitud.nombre_negocio}"?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, rechazar',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#c62828',
            cancelButtonColor: '#64748b',
        });
        if (!confirmar.isConfirmed) return;

        try {
            const r = await fetch(`${baseURL}/solicitudPut.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify({ idSolicitud: solicitud.idSolicitud, estado: 'rechazada' }),
            });
            const data = await r.json();
            if (data.mensaje) {
                toast.success('Solicitud rechazada');
                await cargarSolicitudes();
            } else if (data.error) {
                toast.error(data.error);
            }
        } catch (err) {
            toast.error('Error al rechazar');
        }
    };

    const aprobar = async (solicitud) => {
        const { value: credenciales } = await Swal.fire({
            title: `Aprobar "${solicitud.nombre_negocio}"`,
            html: `
                <p style="font-size:13px;color:#475569;margin-bottom:12px;text-align:left;">
                Creá la base de datos en cPanel y pegá sus credenciales:</p>
                <input id="swal-dbhost" class="swal2-input" placeholder="DB Host (ej: localhost)" value="localhost">
                <input id="swal-dbport" class="swal2-input" placeholder="DB Puerto" value="3306">
                <input id="swal-dbname" class="swal2-input" placeholder="DB Nombre" required>
                <input id="swal-dbuser" class="swal2-input" placeholder="DB Usuario" required>
                <input id="swal-dbpass" class="swal2-input" type="text" placeholder="DB Contraseña" required>
                <input id="swal-adminemail" class="swal2-input" type="email" placeholder="Email admin (opcional)" value="${solicitud.email}">
                <input id="swal-adminpass" class="swal2-input" type="text" placeholder="Contraseña admin (opcional)">
            `,
            showCancelButton: true,
            confirmButtonText: 'Aprobar y crear espacio',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#0d9488',
            cancelButtonColor: '#64748b',
            preConfirm: () => ({
                db_host: document.getElementById('swal-dbhost').value,
                db_port: document.getElementById('swal-dbport').value,
                db_name: document.getElementById('swal-dbname').value,
                db_user: document.getElementById('swal-dbuser').value,
                db_pass: document.getElementById('swal-dbpass').value,
                admin_email: document.getElementById('swal-adminemail').value,
                admin_pass: document.getElementById('swal-adminpass').value,
            }),
        });

        if (!credenciales) return;

        try {
            const r = await fetch(`${baseURL}/provisionarTenant.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify({ idSolicitud: solicitud.idSolicitud, ...credenciales }),
            });
            const data = await r.json();
            if (data.mensaje) {
                await Swal.fire({
                    title: 'Espacio creado',
                    html: `<p style="font-size:14px;">URL: <b>${data.url}</b></p>
                           <p style="font-size:14px;">Admin: <b>${data.admin_email}</b></p>
                           <p style="font-size:14px;">Contraseña: <b>${data.admin_pass}</b></p>`,
                    icon: 'success',
                });
                await cargarSolicitudes();
            } else if (data.error) {
                await Swal.fire({ title: 'Error', text: data.error, icon: 'error' });
            }
        } catch (err) {
            await Swal.fire({ title: 'Error', text: 'Error al aprovisionar', icon: 'error' });
        }
    };

    const borrarCliente = async (cliente) => {
        const confirmar = await Swal.fire({
            title: 'Borrar cliente',
            html: `¿Borrar el cliente <b>/${cliente.slug}</b>?<br><br>
                   Se eliminará su acceso al sistema y sus archivos. Esta acción no se puede deshacer.`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, borrar',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#c62828',
            cancelButtonColor: '#64748b',
        });
        if (!confirmar.isConfirmed) return;

        try {
            const r = await fetch(`${baseURL}/clienteDelete.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify({ slug: cliente.slug }),
            });
            const data = await r.json();
            if (data.mensaje) {
                toast.success(data.mensaje);
                await cargarClientes();
            } else if (data.error) {
                toast.error(data.error);
            }
        } catch (err) {
            toast.error('Error al borrar el cliente');
        }
    };

    if (chequeando) {
        return <div className='master'><p className='masterCargando'>Cargando...</p></div>;
    }

    if (!admin) {
        return (
            <div className='master'>
                <ToastContainer />
                <form className='masterLogin' onSubmit={handleLogin}>
                    <h1>Panel Master</h1>
                    <input type='email' placeholder='Email' value={email} onChange={(e) => setEmail(e.target.value)} required />
                    <input type='password' placeholder='Contraseña' value={password} onChange={(e) => setPassword(e.target.value)} required />
                    <button type='submit'>Ingresar</button>
                </form>
            </div>
        );
    }

    return (
        <div className='master'>
            <ToastContainer />
            <header className='masterHeader'>
                <h1>Panel Master</h1>
                <span className='masterUser'>Admin: {admin.nombre}</span>
            </header>

            <div className='masterTabs'>
                <button className={`masterTab ${tab === 'solicitudes' ? 'activo' : ''}`} onClick={() => setTab('solicitudes')}>
                    Solicitudes
                </button>
                <button className={`masterTab ${tab === 'clientes' ? 'activo' : ''}`} onClick={() => setTab('clientes')}>
                    Clientes
                </button>
            </div>

            {tab === 'solicitudes' ? (
                solicitudes.length === 0 ? (
                    <p className='masterVacio'>No hay solicitudes.</p>
                ) : (
                    <div className='masterLista'>
                        {solicitudes.map((s) => (
                            <div className='masterCard' key={s.idSolicitud}>
                                <div className='masterCardTop'>
                                    <div>
                                        <h3>{s.nombre_negocio}</h3>
                                        <span className='masterSlug'>/{s.slug || 'sin-slug'}</span>
                                    </div>
                                    <span className='masterEstado' style={{ background: ESTADOS[s.estado] || '#666' }}>
                                        {s.estado}
                                    </span>
                                </div>
                                <div className='masterDatos'>
                                    <span><b>Dueño:</b> {s.nombre_dueno}</span>
                                    <span><b>Email:</b> {s.email}</span>
                                    <span><b>Tel:</b> {s.telefono}</span>
                                    <span><b>Tipo:</b> {s.tipo_negocio}</span>
                                    <span><b>Plan:</b> {s.plan}</span>
                                    <span className='masterColorChip'>
                                        <i style={{ background: s.color || '#0D9488' }} />
                                        Color: {s.color || '#0D9488'}
                                    </span>
                                    {s.instagram && <span><b>Instagram:</b> {s.instagram}</span>}
                                    {s.facebook && <span><b>Facebook:</b> {s.facebook}</span>}
                                </div>
                                <div className='masterAcciones'>
                                    {s.estado !== 'aprobada' && (
                                        <button className='btnAprobar' onClick={() => aprobar(s)}>Aprobar</button>
                                    )}
                                    {s.estado !== 'rechazada' && s.estado !== 'aprobada' && (
                                        <button className='btnRechazar' onClick={() => rechazar(s)}>Rechazar</button>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                )
            ) : (
                cargandoClientes && clientes.length === 0 ? (
                    <p className='masterVacio'>Cargando clientes...</p>
                ) : clientes.length === 0 ? (
                    <p className='masterVacio'>No hay clientes.</p>
                ) : (
                    <div className='masterLista'>
                        {clientes.map((c) => (
                            <div className='masterCard' key={c.slug}>
                                <div className='masterCardTop'>
                                    <div>
                                        <h3>{c.nombre_negocio || c.nombre_aplicativo || c.slug}</h3>
                                        <span className='masterSlug'>/{c.slug}</span>
                                    </div>
                                    <span className={`masterEstado ${c.online ? 'masterOnline' : 'masterOffline'}`}>
                                        {c.online ? 'En línea' : 'Desconectado'}
                                    </span>
                                </div>
                                <div className='masterDatos'>
                                    <span><b>Plan:</b> {c.plan}</span>
                                    <span><b>Tipo:</b> {c.tipo_negocio}</span>
                                    <span className='masterColorChip'>
                                        <i style={{ background: c.color || '#0D9488' }} />
                                        Color: {c.color || '#0D9488'}
                                    </span>
                                    <span><b>Tenant:</b> {String(c.tenant_activo) === '1' ? 'Activo' : 'Suspendido'}</span>
                                    {c.usuario_nombre && (
                                        <span><b>Usuario:</b> {c.usuario_nombre} ({c.rol}){c.sesion_email ? ' · ' + c.sesion_email : ''}</span>
                                    )}
                                    <span><b>Último login:</b> {c.sesion_email ? `${c.sesion_email} · ${formatearFecha(c.fecha_login)}` : formatearFecha(c.fecha_login)}</span>
                                    <span><b>Última actividad:</b> {formatearFecha(c.fecha_ultimo_acceso)}</span>
                                </div>
                                <div className='masterAcciones'>
                                    <button className='btnBorrar' onClick={() => borrarCliente(c)}>Borrar</button>
                                </div>
                            </div>
                        ))}
                    </div>
                )
            )}
        </div>
    );
}
